/* eslint no-undef: 0 */

$(document).ready(function() {

    $('.simple-crud-table').DataTable({
        pagingType: 'full_numbers',
    });

    $('.fade-out').delay(4000).fadeOut(4000);

    $('.throws-confirmation').click(function(event) {

        if (!window.confirm('Are you sure you want to disable this user?')) {
            event.preventDefault();
        }

    });

});

Object.defineProperty(Object.prototype, 'getNestedProperty', {
    value: function getNestedProperty(object, field) {
        return field.split('.').reduce((o, i)=>o[i], object);
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/global.js